const rawPromoCollectionIds = process.env.NEXT_PUBLIC_PROMO_COLLECTION_IDS ?? ''
const PROMO_COLLECTION_IDS = new Set<string>(
  rawPromoCollectionIds
    .split(',')
    .map((value) => value.trim())
    .filter(Boolean),
)
const PROMO_CUTOFF_UTC = new Date(
  process.env.NEXT_PUBLIC_PROMO_CUTOFF_UTC ?? '2026-02-19T23:59:00Z',
)
export const PROMO_PROPERTY_ID =
  process.env.NEXT_PUBLIC_PROMO_PROPERTY_ID ??
  '00000000-0000-0000-0000-000000000000'

export const hasPromo = (nftCollectionId?: string | null): boolean => {
  if (!nftCollectionId) return false
  if (new Date() > PROMO_CUTOFF_UTC) return false

  return PROMO_COLLECTION_IDS.has(nftCollectionId)
}

export const isPromoActive = (): boolean => {
  const [firstCollectionId] = Array.from(PROMO_COLLECTION_IDS)
  return hasPromo(firstCollectionId)
}
